import React, { useState } from 'react';
import axios from 'axios';
import {
  Button, Table, message, Upload, Modal, Space,
} from 'antd';
import { UploadOutlined } from '@ant-design/icons';
import { EmptyList } from '../../../../common/ui/Common';
import Config from './TableConfig';
import Preloader from '../../../../pages/private/components/preloader/Preloader';
import DeleteWarning from '../../../../common/ui/Modal/DeleteWarning';
import { useToggle } from '../../../../logic/hooks/useToggle';
import { useSearchPropsFactory } from '../../../../pages/private/utils/useSearch';

function ReserveTable({
  reserveList, fetchData, preloader,
}) {
  const [copyName, setCopyName] = useState(false);
  const [showDelWarn, setShowDelWarn] = useToggle(false);
  const [showRestoreModal, setShowRestoreModal] = useState(false);
  const [fileList, setFileList] = useState([]);
  const [uploading, setUploading] = useState(false);

  const handleTableIcon = async (e, row) => {
    const { dataset } = e.target;
    const {
      name,
    } = row;
    if (dataset.name === 'del') {
      setCopyName(name);
      // setCopyPath(path);
      setShowDelWarn();
    } else if (dataset.name === 'download') {
      const token = window.localStorage.getItem('token');
      const filename = name;

      try {
        const response = await fetch(`/api/download/backup/${filename}?token=${token}`);

        if (!response.ok) {
          const errorData = await response.json();
          message.error(errorData.error.text.rus);
          return;
        }
        const blob = await response.blob();
        const downloadUrl = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = downloadUrl;
        a.download = filename;
        document.body.appendChild(a);
        a.click();
        window.URL.revokeObjectURL(downloadUrl);
        document.body.removeChild(a);
        message.success('Файл успешно скачан');
      } catch (error) {
        message.error('Ошибка сети при скачивании файла');
      }
    }
  };

  const createCopy = async () => {
    preloader();
    try {
      await axios({
        method: 'post',
        url: '/api/createbackup',
        data: {
          token: window.localStorage.getItem('token'),
        },
        json: true,
      });
      preloader();
      fetchData();
    } catch (e) {
      preloader();
    }
  };

  const convertFileToBase64 = (file) => new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      const base64String = reader.result.split(',')[1];
      resolve(base64String);
    };
    reader.onerror = (error) => reject(error);
  });

  const handleRestore = async () => {
    if (fileList.length === 0) {
      message.error('Пожалуйста, выберите файл');
      return;
    }

    const file = fileList[0];

    if (!file.name.endsWith('.sql')) {
      message.error('Файл должен иметь расширение .sql');
      return;
    }

    setUploading(true);

    try {
      const base64Content = await convertFileToBase64(file);
      const token = window.localStorage.getItem('token');

      const response = await axios.post(
        `/server/api/importdbfromsqlfile/?action=update&token=${token}`,
        {
          data: {
            filename: file.name,
            content: base64Content,
          },
        },
      );

      if (response.data.status === 'success') {
        message.success(response.data.message || 'Процесс восстановления базы данных запущен');
        setShowRestoreModal(false);
        setFileList([]);
      } else {
        message.error('Ошибка при восстановлении базы данных');
      }
    } catch (error) {
      message.error(error.response?.data?.error?.text?.rus || 'Ошибка при восстановлении базы данных');
    } finally {
      setUploading(false);
    }
  };

  const uploadProps = {
    onRemove: (file) => {
      const index = fileList.indexOf(file);
      const newFileList = fileList.slice();
      newFileList.splice(index, 1);
      setFileList(newFileList);
    },
    beforeUpload: (file) => {
      setFileList([file]);
      return false;
    },
    fileList,
    maxCount: 1,
    accept: '.sql',
  };

  const Setting = Config(useSearchPropsFactory());
  const { columns } = Setting;

  const viewReserve = reserveList.length
    ? (
      <Table
        keys="name"
        dataSource={reserveList}
        onRow={(row) => ({
          onClick: (e) => { handleTableIcon(e, row); },
        })}
        columns={columns}
      />
    ) : <EmptyList>Резервных копий нет</EmptyList>;

  return (
    <>
      <Space style={{ marginBottom: 16 }}>
        <Button type="primary" onClick={createCopy}>Создать копию</Button>
        <Button onClick={() => setShowRestoreModal(true)}>Восстановить из файла</Button>
      </Space>
      {!reserveList ? <Preloader isOpen small /> : viewReserve}
      <DeleteWarning
        confirmDel={() => { }}
        name={copyName}
        isOpen={showDelWarn}
        toggleOpen={setShowDelWarn}
      />
      <Modal
        title="Восстановление из резервной копии"
        open={showRestoreModal}
        onOk={handleRestore}
        onCancel={() => {
          setShowRestoreModal(false);
          setFileList([]);
        }}
        confirmLoading={uploading}
        okText="Восстановить"
        cancelText="Отмена"
      >
        <p style={{ marginBottom: 16 }}>
          Выберите файл резервной копии (.sql) для восстановления базы данных
        </p>
        <Upload.Dragger {...uploadProps}>
          <p className="ant-upload-drag-icon">
            <UploadOutlined />
          </p>
          <p className="ant-upload-text">Нажмите или перетащите файл в эту область</p>
          <p className="ant-upload-hint">
            Поддерживается только формат .sql
          </p>
        </Upload.Dragger>
      </Modal>
    </>
  );
}

export default React.memo(ReserveTable);
